<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import FallbackAvatar from '@/components/ui/FallbackAvatar'

  export default {
    name: 'ProfileTopLeftSection',
    components: {
      FallbackAvatar,
    },
    props: {
      isOwn: Boolean,
      isAdminUrl: String,
      avatarStyleClass: String,
    },
    computed: {
      ...mapState('users', [
        'user',
        'followedUsers',
      ]),
      ...mapState('auth', { activeUser: 'user' }),
      ...mapState('auth', ['settings']),
      userStatus() {
        return this.user.status ? this.user.status.text : ''
      },
      isFollowing() {
        return this.followedUsers && this.followedUsers.includes(parseInt(this.$route.params.id))
      },
    },
    mounted() {
      this.getFollowedUsersList(this.activeUser && this.activeUser.user_id)
    },
    methods: {
      ...mapActions('users', [
        'getFollowedUsersList',
        'followUser',
        'unfollowUser',
      ]),
      userConversation() {
        this.$emit('userConversation')
      },
      toggleOverlay() {
        this.$emit('toggleOverlay')
      },
      followSelectedUser() {
        this.followUser({ activeUserId: this.activeUser.user_id, selectedUserId: parseInt(this.$route.params.id) }).then(_ =>{
          this.getFollowedUsersList(this.activeUser.user_id)
        })
      },
      unfollowSelectedUser() {
        this.unfollowUser({ activeUserId: this.activeUser.user_id, selectedUserId: parseInt(this.$route.params.id) }).then(_ =>{
          this.getFollowedUsersList(this.activeUser.user_id)
        })
      },
    },
  }
</script>
